module.exports = {
    supportedLocales: [
        {id: 'en-ca', alias: ''},
        {id: 'en-gb', alias: 'eu/gb/en'},
        {id: 'en-fr', alias: 'eu/fr/en'},
        {id: 'en-de', alias: 'eu/de/en'},
        {id: 'en-at', alias: 'eu/at/en'},
        {id: 'en-gr', alias: 'eu/gr/en'},
        {id: 'en-hu', alias: 'eu/hu/en'},
        {id: 'en-is', alias: 'eu/is/en'},
        {id: 'en-bg', alias: 'eu/bg/en'},
        {id: 'en-cy', alias: 'eu/cy/en'},
        {id: 'en-dk', alias: 'eu/dk/en'},
        {id: 'en-ee', alias: 'eu/ee/en'},
        {id: 'en-fi', alias: 'eu/fi/en'},
        {id: 'en-cz', alias: 'eu/cz/en'},
        {id: 'en-hr', alias: 'eu/hr/en'},
        {id: 'en-ie', alias: 'eu/ie/en'},
        {id: 'en-be', alias: 'eu/be/en'},
        {id: 'en-it', alias: 'eu/it/en'},
        {id: 'en-lv', alias: 'eu/lv/en'},
        {id: 'en-li', alias: 'eu/li/en'},
        {id: 'en-lt', alias: 'eu/lt/en'},
        {id: 'en-lu', alias: 'eu/lu/en'},
        {id: 'en-mt', alias: 'eu/mt/en'},
        {id: 'en-md', alias: 'eu/md/en'},
        {id: 'en-nl', alias: 'eu/nl/en'},
        {id: 'en-pl', alias: 'eu/pl/en'},
        {id: 'en-ro', alias: 'eu/ro/en'},
        {id: 'en-sk', alias: 'eu/sk/en'},
        {id: 'en-no', alias: 'eu/no/en'},
        {id: 'en-si', alias: 'eu/sl/en'},
        {id: 'en-pt', alias: 'eu/pt/en'},
        {id: 'en-es', alias: 'eu/es/en'},
        {id: 'en-se', alias: 'eu/se/en'},
        {id: 'en-ch', alias: 'eu/ch/en'},
        {id: 'de-de', alias: 'eu/de/de'},
        {id: 'de-li', alias: 'eu/li/de'},
        {id: 'de-be', alias: 'eu/be/de'},
        {id: 'de-at', alias: 'eu/at/de'},
        {id: 'de-lu', alias: 'eu/lu/de'},
        {id: 'de-nl', alias: 'eu/nl/de'},
        {id: 'de-ch', alias: 'eu/ch/de'},
        {id: 'fr-fr', alias: 'eu/fr/fr'},
        {id: 'fr-be', alias: 'eu/be/fr'},
        {id: 'fr-nl', alias: 'eu/nl/fr'},
        {id: 'fr-lu', alias: 'eu/lu/fr'},
        {id: 'fr-it', alias: 'eu/it/fr'},
        {id: 'fr-ch', alias: 'eu/ch/fr'},
        {id: 'fr-mc', alias: 'eu/mc/fr'},
        {id: 'en-mc', alias: 'eu/mc/en'}
    ]
}
